/**
 * Haptics do design system.
 *
 * Tabela de uso (05-motion.md § Haptics):
 *   selection — trocar aba, mover o ArcSelector, tick do RulerPicker, Toggle
 *   light     — botão comum, curtir, republicar, abrir sheet, marcar série
 *   medium    — abrir câmera, disparo, encaixar sheet, iniciar treino
 *   success   — check-in, level up, conquista, ofensiva mantida, refeição registrada
 *   warning   — modal de confirmação, ofensiva em risco
 *   error     — erro de campo, erro de OTP, falha de rede
 *   heavy     — segurar para reordenar
 *
 * Silencioso por contrato: em web, com o plugin ausente ou se a chamada
 * falhar, não faz nada e não lança. Vibração é enfeite; nunca pode
 * derrubar um fluxo.
 *
 * O plugin é carregado sob demanda no primeiro toque, para não pesar no
 * boot de quem nunca dispara um haptic.
 */

import { Capacitor } from '@capacitor/core';

const nativo = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

let modulo = null;
let carregando = null;
let desligado = false;

async function plugin() {
  if (desligado || !nativo()) return null;
  if (modulo) return modulo;
  if (!carregando) {
    carregando = import('@capacitor/haptics')
      .then((m) => {
        modulo = m;
        return m;
      })
      .catch(() => {
        // plugin não instalado no binário nativo: desliga de vez
        desligado = true;
        return null;
      });
  }
  return carregando;
}

/** Executa e engole qualquer falha. */
async function tentar(fn) {
  const m = await plugin();
  if (!m) return;
  try {
    await fn(m);
  } catch {
    /* silencioso por contrato */
  }
}

const impacto = (estilo) => tentar((m) => m.Haptics.impact({ style: m.ImpactStyle[estilo] }));
const aviso = (tipo) => tentar((m) => m.Haptics.notification({ type: m.NotificationType[tipo] }));

export const haptics = {
  /** Passo de seleção: tab, tick de régua, arco, toggle. */
  selection: () => tentar((m) => m.Haptics.selectionChanged()),

  /** Toque comum. */
  light: () => impacto('Light'),

  /** Ação de peso: câmera, disparo, encaixe de sheet. */
  medium: () => impacto('Medium'),

  /** Segurar para reordenar. */
  heavy: () => impacto('Heavy'),

  /** Conclusão positiva. */
  success: () => aviso('Success'),

  /** Confirmação e alerta. */
  warning: () => aviso('Warning'),

  /** Erro de campo, de código ou de rede. */
  error: () => aviso('Error'),
};

export default haptics;
